import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { whatsappLink } from '../mock';

export const HeroSection = () => {
  const scrollToOrcamento = () => {
    const element = document.getElementById('orcamento');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-gray-50 to-blue-50 pt-20">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#8B3A9C] opacity-10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#F4D03F] opacity-10 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="space-y-4">
              <div className="inline-block">
                <span className="bg-[#F4D03F] text-[#0A2540] px-4 py-2 rounded-full text-sm font-semibold">
                  O Futuro do Transporte
                </span>
              </div>
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-[#0A2540] leading-tight">
                Logística rápida, segura e conectada
                <span className="text-[#8B3A9C]"> com você</span>
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed">
                Transporte urbano e rodoviário com rastreamento em tempo real e atendimento direto via WhatsApp. Sua carga em boas mãos.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                onClick={scrollToOrcamento}
                size="lg"
                className="bg-[#0A2540] hover:bg-[#8B3A9C] text-white font-semibold px-8 py-6 text-lg group">

                Solicitar Orçamento
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
              </Button>
              <Button
                asChild
                size="lg"
                variant="outline"
                className="border-2 border-[#25D366] text-[#25D366] hover:bg-[#25D366] hover:text-white font-semibold px-8 py-6 text-lg">

                <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
                  Falar no WhatsApp
                </a>
              </Button>
            </div>

            <div className="grid grid-cols-3 gap-6 pt-8">
              <div className="text-center">
                <p className="!font-bold !text-3xl text-[#0A2540]">500+</p>
                <p className="!text-sm text-gray-600">Clientes Atendidos</p>
              </div>
              <div className="text-center">
                <p className="text-3xl font-bold text-[#8B3A9C]">10k+</p>
                <p className="text-sm text-gray-600">Entregas Realizadas</p>
              </div>
              <div className="text-center">
                <p className="text-3xl font-bold text-[#F4D03F]">98%</p>
                <p className="text-sm text-gray-600">Satisfação</p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative z-10">
              <img
                src="https://customer-assets.emergentagent.com/job_00e0f814-3c26-447a-bd3b-37651b824f95/artifacts/p2flxue1_VIBE%20LOG_Foto.png"
                alt="Caminhão VIBE LOG"
                className="w-full h-auto rounded-2xl shadow-2xl" />

            </div>
            <div className="absolute -bottom-6 -right-6 w-full h-full bg-[#8B3A9C] rounded-2xl -z-10"></div>
          </div>
        </div>
      </div>
    </section>);

};